import React from 'react';

import {AlertInfo} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

const {sentSuccessfully} = translations['pt-br'].privateFlow.requestAuthorizations.attachments;
export const SendAttachSuccessAlert = () => (
	<AlertInfo.Root
		severity="success"
		sx={{borderRadius: 0}}
		icon={<Icon name="check-circle-outline-filled" />}>
		<AlertInfo.Title title={sentSuccessfully} />
	</AlertInfo.Root>
);
